import { render } from "./main-carousel.vue?vue&type=template&id=4c4e8c56&scoped=true&ts=true"
import script from "./main-carousel.vue?vue&type=script&lang=ts"
export * from "./main-carousel.vue?vue&type=script&lang=ts"

import "./main-carousel.vue?vue&type=style&index=0&id=4c4e8c56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4e8c56"]])

export default __exports__